module.exports = __webpack_public_path__ + "img/advertiser.d38a097c.svg";